import React, { useState } from 'react';
import RegisterComponent from './RegisterComponent';
import LoginComponent from './LoginComponent';
import { appText } from '../../texts';

const { loginText } = appText;

export default function Login() {
    const [activeTab, setActiveTab] = useState('login');

    return (
        <div className='bg-lightBg lg:min-h-screen flex flex-col-reverse lg:flex-row'>
            <div className='w-full lg:w-1/2 flex flex-col justify-center items-center'>
                <div className='flex space-x-4 my-4 w-1/2 justify-center'>
                    {['login', 'register'].map((tab) => (
                        <button
                            key={tab}
                            className={`py-2 px-4 mx-3 rounded-[25px] transition-all duration-300 ${activeTab === tab ? 'bg-[#0A98ED] text-white' : 'bg-[#DFF0FF] text-[#34B0FC]'
                                }`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab === 'login' ? loginText.btnLogin : loginText.btnRegister}
                        </button>
                    ))}
                </div>
                <div className='w-full'>
                    {activeTab === 'login' ? <LoginComponent onLoginSuccess={() => console.log('Login Successful')} /> : <RegisterComponent />}
                </div>
            </div>
            <div className='w-full lg:w-1/2 flex justify-center items-center bg-no-repeat bg-cover h-[30vh] md:h-screen'
                style={{ backgroundImage: `url(images/loginPage.png)` }}>
                <img src='images/logoName.svg' className='w-[20%]' alt='Logo' />
            </div>
        </div>
    );
}
